<template>
	<div id="details">
		<!-- 头部 -->
		<div class="page-header">
			<div class="title">
				<p>当前位置：<a class="nav-home" href="#/">首页</a><i class="el-icon-arrow-right"></i>{{productDetails.offerName}}
				</p>
			</div>
		</div>
		<!-- 头部END -->
		<!-- 主要内容 -->
		<div class="main">
			<!-- 左侧商品轮播图 -->
			<div class="block">
				<div>
					{{productDetails.offerName}}
				</div>
				<div class="pro-price" :class="{actives:lis}" >
					￥{{(productDetails.price / 100).toFixed(2)}}
				</div>
        <div v-if="discount!=null" class="pro-price" style="display:block">
          ￥{{((productDetails.price / 100)*(discount.discount)/100).toFixed(2)}}
        </div>
				<el-carousel height="560px" style="background: #FFFFFF;">
					<el-carousel-item v-for="item in productPicture" :key="item.id">
						<img style="height:560px;object-fit: contain;width: 100%;" :src="$target + item" :alt="item" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<!-- 左侧商品轮播图END -->

			<!-- 右侧内容区 -->
			<div class="content">
				<!-- 内容区底部按钮 -->
				<div class="button">
					<el-button class="shop-cart" @click="addShopping">立即购买</el-button>
				</div>
				<div class="content-specs">
					<div class="specs">
						<span>商品编号：{{productDetails.offerSn}}</span>
<!--						<span>文件格式：{{productDetails.fileFormat}}</span>-->
					</div>
<!--					<div class="intro">文件大小：{{productDetails.fileSize | changeType}}</div>-->
				</div>
				<div class="content-berif">
					<div>商品简介：</div>
					<div class="content-berif-text">{{productDetails.offerInfo}}</div>
				</div>
        <div v-if="discount != null" class="content-berif">
          <div>折扣信息：</div>
          <div class="content-berif-text">商品购买后有效期为 <h3 style="display:inline">{{discount.effTerm}}</h3> 天<br>
              当前下单可享受<h3 style="display:inline">{{discount.discount}}</h3>折优惠
          </div>
        </div>
			</div>
			<!-- 右侧内容区END -->
		</div>

	</div>
</template>
<script>
import {addBrowse, info} from "@/api/productApi"
	import {createOrder } from "@/api/orderApi"

  export default {
		data() {
			return {
				offerSn: "", // 商品id
				productDetails: "", // 商品详细信息
				productPicture: "",
        discount:"",//商品折扣信息
        lis:""
			};
		},

    created() {
      this.offerSn = this.$route.query.offerSn
      this.getDetails(this.offerSn);
      this.addBrowse(this.offerSn)
    },

		// 通过路由获取商品id
/*		activated() {
			if (this.$route.query.offerSn != undefined) {
				this.offerSn = this.$route.query.offerSn;
			}
		},*/
		filters: {
			changeType(val) {
				if (val == "0") return "0B";
				var k = 1024;
				var sizes = ["B", "KB", "MB", "GB", "TB"];
				let i = Math.floor(Math.log(val) / Math.log(k)); //得出该数字的单位应该是kB?MB
				return (val / Math.pow(k, i)).toPrecision(3) + "" + sizes[i];
			},
		},
		watch: {
			// 监听商品id的变化，请求后端获取商品数据
/*      offerSn: function(val) {
				this.getDetails(val);
        this.addBrowse(val)
			}*/
		},
		methods: {
			// 获取商品详细信息
			async getDetails(val) {
				info(val).then((res) => {
					this.productDetails = res.data
          this.discount = JSON.parse(res.data.discount)
          if (this.discount){
            this.lis = true;
          }else {
            this.lis = false;
          }
					this.productPicture = res.data.image.split(",")
				})
			},
      // 添加预览量
      async addBrowse(val){
        addBrowse(val)
      },

			addShopping() {
				// 判断是否登录,没有登录则显示登录组件
				if (!this.$store.getters.getUser) {
					this.$store.dispatch("setShowLogin", true);
					return;
				}

				let data = {
					productDetails: JSON.stringify(this.productDetails)
				}
				createOrder(data).then((res) => {
					let order = {
						orderSn: res.data.orderNo,
						orderPrice: res.data.orderPrice
					}
					localStorage.setItem("order", JSON.stringify(order))
					this.$router.push({
						path: "/Order",
					});
				})
			},
		}
	};
</script>
<style scoped lang="scss">
	/* 头部CSS */
	#details {
		background: #F4F4F4;
		padding: 0 6.375rem;
	}

	#details .page-header {
		height: 4rem;
	}

	#details .page-header .title {
		width: 78.125rem;
		min-width: 78.125rem;
		height: 4rem;
		line-height: 4rem;
		font-weight: 400;
		color: #9F9F9F;
		cursor: pointer;
	}

	#details .page-header .title p a {
		color: #9F9F9F;
	}

	/* 头部CSS END */

	/* 主要内容CSS */
	#details .main {
		display: flex;
	}

	#details .main .block {
		width: 56.55rem;
		background: #FFFFFF;
		padding: 1.25rem;
	}

	#details .main .block .pro-price {
		color: #CD0606;
		font-weight: bold;
		margin: 0.625rem 0;
	}

	#details .el-carousel .el-carousel__indicator .el-carousel__button {
		background-color: rgba(163, 163, 163, 0.8);
	}

	#details .main .content {
		margin-left: 0.3125rem;
		width: 21.2625rem;
		background: #FFFFFF;
		padding: 0.8375rem;
	}

	#details .main .content .button {
		height: 55px;
		margin: 10px 0 20px 0;
	}

	#details .main .content .button .el-button {
		float: left;
		height: 55px;
		font-size: 16px;
		color: #fff;
		border: none;
		text-align: center;
	}

	#details .main .content .button .shop-cart {
		width: 340px;
		background-color: #0C75EA;
	}

	#details .main .content .button .shop-cart:hover {
		background-color: #0C75EA;
	}

	#details .main .content .content-specs {
		border: 0.0625rem solid #F0F0F0;
		padding: 0.625rem;
		color: #888888;
		font-size: 13px;
	}

	#details .main .content .content-specs .specs {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	#details .main .content .content-specs .intro {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	#details .main .content .content-berif {
		border: 0.0625rem solid #F0F0F0;
		padding: 0.625rem;
		margin-top: 1.25rem;
		color: #888888;
		font-size: 13px;
	}

	#details .main .content .content-berif .content-berif-text {
		margin-top: 10px;
		margin-bottom: 10px;
		color: #989898;
	}


	/* 主要内容CSS END */

	// 微信支付弹框
	.alipay .el-dialog__body {
		background: #FFFFFF;
	}

	.alipay .el-dialog__body .qCode .wechatTitle {
		margin: auto;
		padding: 10px 15px;
		color: #333;
		display: flex;
		justify-content: space-around;
		align-items: center;

	}

	.alipay .el-dialog__body .qCode .wechatTitle .tips {
		flex: 1;
	}

	.alipay .el-dialog__body .qCode .code {
		display: block;
		margin: 10px auto;
		border: 2px solid #F3F4F5;
	}
  .actives {
    text-decoration:line-through;
  }
</style>